import { makeStyles, shorthands } from '@fluentui/react-components';
import Circle from '../../media/circle.svg';
import TriangleDown from '../../media/triangle-down.svg';
import TriangleUp from '../../media/triangle-up.svg';
import Square from '../../media/square.svg';
import Diamond from '../../media/diamond.svg';

export const useCardStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    '& .vnext-legend-labels-container': {
      paddingLeft: '10px',
      paddingTop: '10px',

      '& ul': {
        display: 'flex',
        justifyContent: 'center',
        listStyleType: 'none',

        '& li': {
          minWidth: '60px',
          '& .legend-label': {
            height: '20px',
            paddingLeft: '15PX !important',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'left',
            backgroundPositionY: 'center',
            backgroundSize: '12px 20px',
            marginRight: '5px',
            marginLeft: '5px',
            marginTop: '1px',
            cursor: 'pointer',
            textOverflow: 'ellipsis',
            ...shorthands.overflow('hidden'),
            whiteSpace: 'nowrap',
          },

          '& .legend-label.disabled': {
            opacity: '50%',
          },
        },
        '& li:nth-child(1) .legend-label': {
          backgroundImage: `url("${Circle}")`,
        },
        '& li:nth-child(2) .legend-label': {
          backgroundImage: `url("${Diamond}")`,
        },
        '& li:nth-child(3) .legend-label': {
          backgroundImage: `url("${TriangleDown}")`,
        },
        '& li:nth-child(4) .legend-label': {
          backgroundImage: `url("${TriangleUp}")`,
        },
        '& li:nth-child(5) .legend-label': {
          backgroundImage: `url("${Square}")`,
        },
      },
    },
    '& .highcharts-container': {
      ...shorthands.overflow('visible !important'),

      '& .chart-tooltip': {
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        fontSize: '14px',
        position: 'absolute',
        whiteSpace: 'nowrap',
        color: 'rgb(51, 51, 51)',
        ...shorthands.padding('15px'),
        display: 'block',
        boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        '@supports (backdrop-filter: blur(60px))': {
          backdropFilter: 'blur(60px)',
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
        },

        '& .segment-wrapper': {
          marginBottom: '10px',
        },

        '& .tooltip-name': {
          maxWidth: '400px',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
        },
      },
    },
  },
});

